import { Switch, Route } from "react-router-dom";

import Home from "./pages/Home";
import Trading from "./pages/Trading";
import Farm from "./pages/Farm";
import Pool from "./pages/Pool";
import Staking from "./pages/Staking";

const Routes = () => {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      {/* <Route path="/swap" exact component={Trading} />
      <Route path="/farm" exact component={Farm} />
      <Route path="/pool" exact component={Pool} /> */}
      <Route path="/dapp" exact component={Staking} />
    </Switch>
  );
};

export default Routes;
